import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

import { Button, Header } from "@pentabd/ui";
import { OrderDate } from "@components/OrderDate";
import calculateFromDate from "./calculateFromDate";
import horizontalLabels from "./horizontalLabels";
import chartOptionsData from "./chartOptionsData";

import { getAttendanceSummary } from "@api/attendances";

import { useAttendances } from "@hooks/HRM/attendances/useAttendances";

import { AttendanceSummaryType } from "@type/HRM/attendance-summary";

const AttendanceSummary = () => {
  const { t } = useTranslation();
  const { queryParams } = useAttendances();

  const [activeStatus, setActiveStatus] = useState<number | null>(null);
  const [xAxisLabels, setXAxisLabels] = useState<string[] | void>([]);
  const [fromDate, setFromDate] = useState<string | void>();
  const toDate = new Date().toISOString().substring(0, 10);

  const orderDates = [
    {
      value: `${toDate}`,
      label: t("ATTENDANCE.SUMMARY.TAB.12_MONTHS"),
    },
    {
      value: `${toDate}`,
      label: t("ATTENDANCE.SUMMARY.TAB.30_DAYS"),
    },
    {
      value: `${toDate}`,
      label: t("ATTENDANCE.SUMMARY.TAB.7_DAYS"),
    },
    {
      value: `${toDate}`,
      label: t("ATTENDANCE.SUMMARY.TAB.24_HOURS"),
    },
  ];

  const orderDateAction = (index: number) => {
    setFromDate(() => calculateFromDate(index));
    setXAxisLabels(() => horizontalLabels(index));
    setActiveStatus(index);
  };

  const [series, setSeries] = useState<any>([]); //!!!
  const [options, setOptions] = useState<ApexOptions>(chartOptionsData);

  const actions = [
    <Button fill="outline" size="sm" type="light" htmlType="button">
      {t("ATTENDANCE.SUMMARY.BUTTON_LABEL")}
    </Button>,
  ];

  useEffect(() => {
    getAttendanceSummary(fromDate as string, toDate as string)
      .then((response) => {
        const updatedData: AttendanceSummaryType[] = [];
        response.data.forEach((item) => {
          let updatedRow: any = {
            data: [],
            name: "",
          };
          updatedRow.data = item.data as [];
          updatedRow.name = item.status as string;
          updatedData.push(updatedRow);
        });
        setSeries(updatedData);
        setOptions((prev: ApexOptions) => ({
          ...prev,
          xaxis: {
            categories: xAxisLabels,
          },
        }));
      })
      .catch((err) => console.log(err));
  }, [fromDate, toDate, xAxisLabels]);

  return (
    <div className="px-9 mb-9 rounded-4 border">
      <Header
        headerText={{
          header: t("ATTENDANCE.SUMMARY.LABEL"),
        }}
        actions={actions}
        noBorder
        size="sm"
      />
      <OrderDate
        key="btn-group"
        orderDateData={orderDates}
        activeState={activeStatus}
        action={orderDateAction}
        query={queryParams}
      />
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height="300vh"
      />
    </div>
  );
};

export default AttendanceSummary;
